import type { ReactNode } from 'react';
import type { Permission } from '~/types/auth';
import PermCheck from '~/utils/PermCheck';

const FORBIDDEN_PAGE = <h1>You do not have access to this page.</h1>;

export const restrictPage = (page: ReactNode, ...policyGroups: (Permission | Permission[])[]) =>
  policyGroups.reduceRight<ReactNode>(
    (allowed, permissions) => (
      <PermCheck permissions={permissions} fallback={FORBIDDEN_PAGE}>
        {allowed}
      </PermCheck>
    ),
    page,
  );
